import React from "react"

type SkeletonLoaderProps = {
  rowCount?: number
  columnCount?: number
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  rowCount = 15,
  columnCount = 4
}) => {
  return (
    <div className="animate-pulse">
      <div className="grid grid-cols-4 gap-4 mb-4">
        {[...Array(columnCount)].map((_, idx) => (
          <div
            key={`header-${idx}`}
            className="h-6 bg-gray-100 dark:bg-[#2D3036]"
          ></div>
        ))}
      </div>
      {[...Array(rowCount)].map((_, rowIdx) => (
        <div key={rowIdx} className="grid grid-cols-4 gap-4 mb-2">
          {[...Array(columnCount)].map((_, colIdx) => (
            <div
              key={`row-${rowIdx}-col-${colIdx}`}
              className="h-6 bg-gray-100 dark:bg-[#2D3036]"
            ></div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default SkeletonLoader
